import React, { useContext } from "react"
import PropTypes from "prop-types"
import { searchResult, collections } from "../../lib/prop-types"
import SearchModalContext from "./searchModalContext"
import RecentlyViewed from "./recentlyViewed"
import SearchResultsTabs from "./searchResultsTabs"

const SearchModalBody = ({
  documentationResults,
  apiReferenceResults,
  searchTerm,
  documentationLoading,
  apiReferenceLoading,
  collection
}) => {
  const { viewedResults } = useContext(SearchModalContext)

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {searchTerm === "" ? (
        <RecentlyViewed results={viewedResults} />
      ) : (
        <SearchResultsTabs
          collection={collection}
          documentationResults={documentationResults}
          apiReferenceResults={apiReferenceResults}
          searchTerm={searchTerm}
          documentationLoading={documentationLoading}
          apiReferenceLoading={apiReferenceLoading}
        />
      )}
    </>
  )
}

SearchModalBody.propTypes = {
  documentationResults: PropTypes.arrayOf(PropTypes.shape(searchResult))
    .isRequired,
  apiReferenceResults: PropTypes.arrayOf(PropTypes.shape(searchResult))
    .isRequired,
  searchTerm: PropTypes.string,
  documentationLoading: PropTypes.bool,
  apiReferenceLoading: PropTypes.bool,
  collection: collections
}

SearchModalBody.defaultProps = {
  searchTerm: "",
  documentationLoading: false,
  apiReferenceLoading: false,
  collection: "documentation"
}

export default SearchModalBody
